<template>
  <div class="handover-block">
    <h3 class="handover-block__title">
      {{ $t("view.flow.block.handover.title") }}
    </h3>
    <sel
      :label="$t('view.flow.block.handover.typeLabel')"
      v-model="val.type"
      @input="onInput"
      style="margin-bottom: 6px"
    >
      <option value="pass">{{ $t('view.flow.block.handover.type.pass') }}</option>
      <option value="take">{{ $t('view.flow.block.handover.type.take') }}</option>
      <option value="request">{{ $t('view.flow.block.handover.type.request') }}</option>
    </sel>
    <in
      :label="$t('view.flow.block.handover.appIdLabel')"
      v-model="val.appId"
      @input="onInput"
      style="margin-bottom: 6px"
      v-show="val.type === 'pass'"
    ></in>
    <in
      :label="$t('view.flow.block.handover.metadataLabel')"
      v-model="val.metadata"
      @input="onInput"
    ></in>
  </div>
</template>

<script>
export default {
  data() {
    return {
      val: null
    };
  },
  props: ["value", "blockId"],
  created() {
    this.val = this.value;
  },
  methods: {
    onInput() {
      this.$emit("input", this.val);
      this.$store.commit("SET_FLOW_EDIT_FLAG", [this.blockId, true]);
      this.$store.commit("SET_EDITED", true);
    }
  }
};
</script>

<style lang="scss" scoped>
.handover-block {
  @include flowElementShadow();
  width: 35%;
  background-color: white;
  border-radius: 7px;
  padding: 1px 14px 10px 14px;
  text-align: left;

  &__separator {
    margin-top: 20px;
  }

  &__title {
    margin: 9px 0 12px 0;
    text-align: left;
  }
}
</style>
